<!--
 * @Description: 离散行业
 * @Author: pliybird
 * @Date: 2023-05-25 14:11:17
 * @LastEditTime: 2023-07-25 13:54:33
 * @LastEditors: 陈绍斌 1748362428@qq.com
 * @filePath: Do not edit
-->
<template>
  <Layout>
    <!-- banner -->
    <div>
      <div class="slider-area slider-style-2 variation-3 height-720 bg_image bg_image_fixed" :style="{
        'background-image': `url(${require(`@/assets/images/IndustrySolution/banner/industry-banner-03.png`)})`,
      }">
        <div class="container">
          <div class="row">
            <div class="col-lg-12">
              <div class="inner text-center">
                <h2 class="title" data-aos="fade-up" data-aos-delay="100">
                  {{ $t("solution.disperse.header.title01") }}
                </h2>
                <h4 class="subtitle color-white mb--30" data-aos="fade-up" data-aos-delay="200">
                  {{ $t("solution.disperse.header.title02") }}
                </h4>
                <p class="col-12 offset-lg-3 col-lg-6 description color-white" data-aos="fade-up" data-aos-delay="300">
                  {{ $t("solution.disperse.header.description") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="rn-section-gapBottom industry-banner">
        <div class="container">
          <div class="row">
            <div class="col-lg-10 offset-lg-1">
              <div class="row row--0 align-items-center mt_dec--30 wrapper">
                <div class="col-lg-12 mt_sm--30 mb_sm--30">
                  <div class="content row align-items-center">
                    <div class="col-12 col-lg-2 col-md-2 text-center">
                      <img class="icon" :src="require('@/assets/images/IndustrySolution/banner/industry-banner-icon1.png')
                        " alt="" />
                    </div>
                    <div class="inner col-12 col-lg-10 col-md-10">
                      <h4 class="title mb--10">
                        {{ $t("solution.disperse.header.card.title") }}
                      </h4>

                      <p class="description mb--0">
                        {{ $t("solution.disperse.header.card.description") }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 解决方案 -->
    <section class="rn-section-gap">
      <SectionTitle :title="$t('solution.solutions_title')" description="SOLUTIONS" textAlign="center" />
      <div class="container">
        <DisperseSolutions></DisperseSolutions>
      </div>
    </section>
    <!-- 客户价值 -->
    <custom-value customState="right" pageLayout="leftFour" :list="list"></custom-value>
    <!-- 方案优势 -->
    <disperse-advantage></disperse-advantage>
    <!-- 典型案例 -->
    <ClassicCases :classicCasesData="ClassicCasesData" />
  </Layout>
</template>
  
<script>
import Layout from "@/components/common/Layout";
import SectionTitle from "@/components/elements/sectionTitle/SectionTitle";
import CustomValue from "./components/CustomValue.vue";
import DisperseSolutions from "./components/DisperseComponents/DisperseSolutions.vue";
import ClassicCases from './components/ClassicCases.vue';
import DisperseAdvantage from './DisperseAdvantage.vue';

export default {
  name: "Disperse",
  components: { Layout, SectionTitle, CustomValue, DisperseSolutions, ClassicCases, DisperseAdvantage },
  props: {},
  data() {
    return {
      list: [
        { title: this.$t('solution.disperse.values.tab.tab01') },
        { title: this.$t('solution.disperse.values.tab.tab02') },
        { title: this.$t('solution.disperse.values.tab.tab03') },
        { title: this.$t('solution.disperse.values.tab.tab04') }
      ],
      //产品案例
      ClassicCasesData: [

        {
          // imageBackground: require('@/assets/images/IndustrySolution/ClassicCases/KyowaKIRIN-background.png'),
          brandIcon: require('@/assets/images/IndustrySolution/ClassicCases/NORMA-GROUP.png'),
        },
        {
          // imageBackground: require('@/assets/images/IndustrySolution/ClassicCases/KyowaKIRIN-background.png'),
          brandIcon: require('@/assets/images/IndustrySolution/ClassicCases/disperse_icon01.jpg'),
        }
      ]
    };
  },
  methods: {},
};
</script>